import usePromoCountdown from "../../../context/usePromoCountdown"
import useStrings from "../../../localization/useStrings"
import styles from "./CyberMonday2025Header.module.scss"
import CyberTag from "./CyberTag"

const CyberMonday2025Header = () => {
  const { minutes, hours, seconds } = usePromoCountdown()
  const strings = useStrings()

  return (
    <div className={styles.header}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>
          <span className={styles.titleCyber}>CYBER</span>
          <span className={styles.titleMonday}>MONDAY</span>
          <div className={styles.cyberTag}>
            <CyberTag />
          </div>
        </div>
      </div>

      <div className={styles.countdown}>
        <div className={styles.countdownTime}>
          {hours.toString().padStart(2, "0")}:
          {minutes.toString().padStart(2, "0")}:
          {seconds.toString().padStart(2, "0")}
        </div>
        <div className={styles.countdownLabel}>
          {strings.cyberMonday.timeRemaining}
        </div>
      </div>
    </div>
  )
}

export default CyberMonday2025Header
